<template>
  <v-tooltip bottom :content-class="copied ? 'copy-tooltip-success' : 'copy-tooltip-default'">
    <template v-slot:activator="{on}">
      <span class="badge" v-on="on" @click.stop.prevent="copyId">
        <slot>{{prefix}}{{id}}</slot>
      </span>
    </template>
    <span class="caption flex items-center gap-1" :class="copied ? 'text-success-text' : 'text-primary-text'">
      <v-icon v-if="copied" small>mdi-check</v-icon>
      <v-icon v-else small>mdi-content-copy</v-icon>
      {{ I18NGetter().useCopyId.COPY }}
    </span>
  </v-tooltip>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { useInstance } from '@/composables/useInstance';
import { I18NGetter } from '@/services/enumTranslator/I18NGetter';

const { $clipboard } = useInstance();

const props = withDefaults(defineProps<{
  id: number;
  prefix?: string;
  hideSnackbar?: boolean;
}>(), {
  prefix: '',
  hideSnackbar: true,
});

const copied = ref(false);
let timeout: ReturnType<typeof setTimeout> | null = null;

const copyId = () => {
  $clipboard(props.id.toString(), !props.hideSnackbar);
  copied.value = true;

  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(() => {
    copied.value = false;
  }, 2000);
};
</script>
<style scoped lang="scss">
.badge {
  font-weight: 300;

  &:hover {
    cursor: pointer;
    color: var(--token-primary-text);
  }
}
</style>

<style lang="scss">
.copy-tooltip-default,
.copy-tooltip-success {
  padding: 8px 16px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.copy-tooltip-default {
  background-color: var(--token-core-surface) !important;
  & .v-icon {
    color: var(--token-core-onCore-highEmphasis) !important;
  }
}

.copy-tooltip-success {
  background-color: var(--token-success-base) !important;
  & .v-icon {
    color: var(--token-success-onBase-highEmphasis) !important;
  }
}
</style>
